import { IWishlistData } from './Wishlist.domain';
import instance, { apiImageInstance } from '@/common/service/api/Axios';
import { ApiUrls } from '@/common/domain/Endpoints.domain';
import { TSlug } from '@/common/domain/Slug.domain';

export const fetchPreviewById = async (id: string) => {
    try {
        const response = await instance.get<IWishlistData>(
            `${ApiUrls.activity.root}/${parseInt(id)}/no-cache`
        );

        return response.data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const fetchUserImagesByActivityIds = (activity_ids: string) => {
    if (!activity_ids) return [];

    return apiImageInstance
        .get<TSlug[]>(ApiUrls.photo.excerpt, { params: { activity_ids } })
        .then(({ data }) => data)
        .catch(() => []);
};
